import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import AdjustmentDeliveryNoteStatusBar, { AdjustmentDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../AdjustmentDNStatusBar'
import AdjustmentDeliveryNoteCreateStepButtons, { AdjustmentDeliveryNoteCreateStepButtonsNew } from '../AdjustmentDNCreateStepButtons'

type AdjustmentDeliveryNoteCreateStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const AdjustmentDeliveryNoteCreateStepHeaderDecider: React.FC<AdjustmentDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={AdjustmentDeliveryNoteCreateStepHeaderDefault} NewComponent={AdjustmentDeliveryNoteCreateStepHeaderNew} {...rest} />
    )
}

const AdjustmentDeliveryNoteCreateStepHeaderDefault: React.FC<AdjustmentDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <AdjustmentDeliveryNoteStatusBar {...rest} />
            <AdjustmentDeliveryNoteCreateStepButtons {...rest} />
        </div>
    )
}

const AdjustmentDeliveryNoteCreateStepHeaderNew: React.FC<AdjustmentDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <AdjustmentDeliveryNoteStatusBarNew {...rest} />
            <AdjustmentDeliveryNoteCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default AdjustmentDeliveryNoteCreateStepHeaderDecider